// export function setupSlideToggle(triggerSelector, contentSelector) {

//   function initMenu() {
//     const width = window.innerWidth;

//     // Only run below 1200px
//     if (width >= 1200) {
//       // Clean up everything when going back to desktop
//       $(contentSelector).removeAttr("style"); 
//       $(triggerSelector).removeClass("menu-open").off("click");
//       return;
//     }

//     // Mobile behavior
//     $(triggerSelector).each(function () {
//       $('.contain-mega-menu__content').css('max-height', 'revert');
//       const $trigger = $(this);
//       // const $content = $trigger.closest("li").find(contentSelector);
//       window.alert("First alert for content", $content);
//       const megaMenuAnchor = $content.find('.contain-mega-menu__link');
//       // window.alert("Second alert for mega menu link", megaMenuAnchor)
//       // Hide initially
//       $content.hide();


//       // Remove duplicate handlers
//       $trigger.off("click").on("click", function (e) {
//         e.preventDefault();

//         const $allTriggers = $(triggerSelector);
//         const $allContents = $(contentSelector);

//         // Stop animations
//         $allContents.stop(true, true);

//         if ($content.is(":visible")) {
//           // Close current
//           $content.slideUp(300);
//           $trigger.removeClass("menu-open");
//         } else {
//           // Close others
//           $allContents.not($content).slideUp(300);
//           $allTriggers.not($trigger).removeClass("menu-open");

//           // Open current
//           $content.slideDown(300);
//           $trigger.addClass("menu-open");
//         }
//       });

//       $(megaMenuAnchor).on("click", function(e){

//         const $allTriggers = $(triggerSelector);
//         const $allContents = $(contentSelector);
        
//         // Stop animations
//         $allContents.stop(true, true);
//         $allContents.slideUp(300);
//         $allTriggers.removeClass("menu-open");

//         const menuoffCanvas = document.getElementById('offcanvasNavbar');
//         const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(menuoffCanvas);
//         offcanvas.hide();
//       });
//     });
//   }

//   // Run initially
//   initMenu();

//   // Run again on resize
//   $(window).off("resize.menu").on("resize.menu", function () {
//     initMenu();
//   });
// }


export function setupSlideToggle(triggerSelector, contentSelector) {
 
  const offcanvasEl = document.getElementById("offcanvasNavbar");
  let isSubMenuClick = false;
 
  function initMenu() {
    const width = window.innerWidth;
 
    /* ===============================
       DESKTOP RESET
    =============================== */
    if (width >= 1200) {
      $(contentSelector).removeAttr("style");
      $(triggerSelector).removeClass("menu-open");
      return;
    }
    $(contentSelector).hide();
 
    $(".contain-mega-menu__content").css("max-height", "revert");
 
    // Remove ALL previous handlers
    $(document)
      .off(".menuToggle")
      .off(".menuLink");
 
    /* ===============================
       SUB MENU TOGGLE
    =============================== */
    $(document).on("click.menuToggle", triggerSelector, function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // 🔥 VERY IMPORTANT
 
      isSubMenuClick = true;
 
      const $trigger = $(this);
      const $content = $trigger.closest("li").find(contentSelector);
 
      const $allTriggers = $(triggerSelector);
      const $allContents = $(contentSelector);
 
      $allContents.stop(true, true);
 
      if ($content.is(":visible")) {
        $content.slideUp(250);
        $trigger.removeClass("menu-open");
      } else {
        $allContents.not($content).slideUp(250);
        $allTriggers.not($trigger).removeClass("menu-open");
 
        $content.slideDown(250);
        $trigger.addClass("menu-open");
      }
 
      // Allow offcanvas again after click cycle
      setTimeout(() => {
        isSubMenuClick = false;
      }, 0);
    });
 
    /* ===============================
       PAGE NAVIGATION CLICK
    =============================== */
    $(document).on("click.menuLink", ".contain-mega-menu__link, .offcanvas-btn", function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
 
      $(contentSelector).stop(true, true).slideUp(0);
      $(triggerSelector).removeClass("menu-open");
 
      if (offcanvasEl) {
        bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl).hide();
      }
    });
  }
 
  /* ===============================
     BLOCK BOOTSTRAP AUTO CLOSE
  =============================== */
  if (offcanvasEl) {
 
    // Prevent backdrop click close when submenu clicked
    offcanvasEl.addEventListener("hide.bs.offcanvas", (e) => {
      if (isSubMenuClick) {
        e.preventDefault(); // 🔥 STOP BOOTSTRAP
      }
    });
 
    // Kill focus-trap interference
    offcanvasEl.addEventListener("focusin", (e) => {
      if (isSubMenuClick) {
        e.stopImmediatePropagation();
      }
    }, true);
  }
 
  /* ===============================
     INIT + RESIZE
  =============================== */
  initMenu();
 
  $(window)
    .off("resize.menu")
    .on("resize.menu", initMenu);
}